
const burger_menu = () => {
    $('.burger-menu').on('click', () => {
        $('nav').toggleClass('change');
        $('.burger-menu').toggleClass('transform-burger-lines');

        if ($('nav').hasClass('change')) {
            fadeNavLinksIn();
        } else {
            fadeNavLinksOut();
        }
    });
    function fadeNavLinksIn() {
        $('nav ul li').each(function (index) {
            setTimeout(() => {
                $(this).addClass('nav-fade-in');
            }, index * 80);
        });
    }

    function fadeNavLinksOut() {
        $('nav ul li').removeClass('nav-fade-in');
    }
}
export default burger_menu;